import { FC } from "react";
import { StyleSheet, TextProps, View, ViewProps } from "react-native";
import { kColors } from "src/kColors";
import { kFonts } from "src/kFonts";
import { kStyleConst } from "src/kStyle";

import { PdText } from "./typography";

export const PdTag: FC<ViewProps> = ({ style, ...rest }) => {
  return <View style={[styles.pdTag, style]} {...rest} />;
};

export const PdTagLabel: FC<TextProps> = ({ style, ...rest }) => {
  return <PdText style={[styles.pdTagLabel, style]} numberOfLines={1} {...rest} />;
};

const styles = StyleSheet.create({
  pdTag: {
    alignItems: "center",
    backgroundColor: kColors.brandGreen,
    borderRadius: 999,
    height: kStyleConst.kStoreFrontExclusiveBadgeHeight,
    justifyContent: "center",
    paddingHorizontal: 2 * kStyleConst.kSpacing,
  },
  pdTagLabel: {
    ...kFonts.bodySmallCenter,
    color: kColors.white,
    fontWeight: "400",
    height: kStyleConst.kStoreFrontExclusiveBadgeHeight,
    letterSpacing: kStyleConst.kSlightLetterSpacing,
    lineHeight: kStyleConst.kStoreFrontExclusiveBadgeHeight,
  },
});
